import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ContactUs = () => {
    return (
        <div>
            <Header/>
       
        <div>
            <div className="page-heading header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Contact Us</h1>
                            <span>Feel free to send us a message now!</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-information">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="contact-item">
                                <i className="fa fa-facebook"></i>
                                <h4>Facebook</h4>
                                <p>Connect with Success!</p>
                                <a href="https://www.facebook.com/CreLab/photos?locale=fr_FR">Creative Lab ISI</a>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="contact-item">
                                <i className="fa fa-envelope"></i>
                                <h4>Email</h4>
                                <p>Unlock Opportunities – Email Us Today!</p>
                                <a href="#">creative.lab.club@gmail.com</a>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="contact-item">
                                <i className="fa fa-map-marker"></i>
                                <h4>Location</h4>
                                <p>2 Rue Abou Raihane Bayrouni 2080 ,Ariana<br /></p>
                                <a href="https://maps.google.com/?q=36.8665,10.1647">Voir sur Google Maps</a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="callback-form contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-heading">
                                <h2>Send us a <em>message</em></h2>
                                <span>FEEL FREE TO SEND US A MESSAGE NOW!</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="contact-form">
                                <form id="contact" action="" method="get">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <fieldset>
                                                <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <fieldset>
                                                <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <fieldset>
                                                <input name="subject" type="text" className="form-control" id="subject" placeholder="Subject" required />
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-12">
                                            <fieldset>
                                                <textarea name="message" rows="6" className="form-control" id="message" placeholder="Your Message" required ></textarea>
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-12">
                                            <fieldset>
                                                <button type="submit" id="form-submit" className="filled-button">Send Message</button>
                                            </fieldset>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="map">
                {/* How to change your own map point
                    1. Go to Google Maps
                    2. Click on your location point
                    3. Click "Share" and choose "Embed map" tab
                    4. Copy only URL and paste it within the src="" field below
                */}
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6530.721437343966!2d10.180416365322516!3d36.86420905917351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e2cb4b0ecda8a3%3A0xc561ba5428c31de3!2sISI%20Ariana!5e0!3m2!1sfr!2stn!4v1758384216181!5m2!1sfr!2stn" width="100%" height="450" style={{border:0}} allowfullscreen="true"  referrerpolicy="no-referrer-when-downgrade"></iframe>            </div>

         

        </div>
        <Footer/>
        </div>
    );
};

export default ContactUs;
